module.exports = __webpack_public_path__ + "img/defence-24.e9d77f6b.svg";